import { useFormContext, useWatch } from "react-hook-form";
import { geoCode } from "../../../../utils/constants/countryCodes";
import { cityCode, villageCode } from "../step3/utils";
import { useEffect } from "react";

function useAddress(prefix) {
  const [country, cityOrVillage, georgianCity] = useWatch({
    name: [
      `${prefix}.country`,
      `${prefix}.cityOrVillage`,
      `${prefix}.georgianCity`,
    ],
  });

  const { resetField, register } = useFormContext();

  const isGeorgia = country?.value === geoCode;
  const isGeorgianCity = isGeorgia && cityOrVillage?.value === cityCode;
  const isVillage = isGeorgia && cityOrVillage?.value === villageCode;

  function handleCountryChange() {
    [
      `${prefix}.village`,
      `${prefix}.city`,
      `${prefix}.cityOrVillage`,
      `${prefix}.georgianCity`,
      `${prefix}.street`,
      `${prefix}.houseNumber`,
      `${prefix}.apartmentNumber`,
    ].forEach(resetField);
  }

  function handleVillageOrCityChange() {
    [
      `${prefix}.village`,
      `${prefix}.georgianCity`,
      `${prefix}.street`,
      `${prefix}.houseNumber`,
      `${prefix}.apartmentNumber`,
    ].forEach(resetField);
  }
  function handleGeorgianCityChange() {
    [
      `${prefix}.street`,
      `${prefix}.houseNumber`,
      `${prefix}.apartmentNumber`,
    ].forEach(resetField);
  }

  return {
    showCityTextInput: !isGeorgia,
    handleVillageOrCityChange,
    handleGeorgianCityChange,
    handleCountryChange,
    isGeorgianCity,
    isGeorgia,
    isVillage,
    register,
  };
}

export { useAddress };
